import { ActionTypes } from "../constants";

/* eslint-disable */

export const initializeDevice = () => ({
    type: ActionTypes.DEVICE_INIT_REQUEST
});

export const logoutDevice = () => ({
    type: ActionTypes.DEVICE_LOGOUT_REQUEST
});

export const getDeviceStatus = () => ({
    type: ActionTypes.DEVICE_STATUS_REQUEST
});

export const requestNotificationPermission = () => ({
    type: ActionTypes.REQUEST_NOTIFICATION_PERMISSION
});